/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventHistoricEntity } from './eventHistoricEntity';
import { GeoLocationEntity } from './geoLocationEntity';


export interface EventProps { 
    _id?: string;
    acceptAnyLvl: boolean;
    attendees: Array<string>;
    pendingInvitees?: Array<string>;
    backgroundUrl?: string;
    description: string;
    duration: number;
    distance: number;
    verticalDrop: number;
    endDate?: string;
    level: number;
    location: GeoLocationEntity;
    maxNbAttendees: number;
    attendeesMode?: EventProps.AttendeesModeEnum;
    pace: string;
    ownerId: string;
    sessionKindId: string;
    privacy: EventProps.PrivacyEnum;
    sportId: string;
    startDate: string;
    status: object;
    title: string;
    historics: Array<EventHistoricEntity>;
    groupId?: string;
    isRecurring?: boolean;
    recurrenceSeriesId?: string;
    type?: string;
    costPerParticipant?: number;
    isPaidOut?: boolean;
    commissionPercent?: number;
    routeUrl?: string;
    deletedAt?: string;
    deletedBy?: string;
    reminder1hSentAt?: string;
    reminder1dSentAt?: string;
}
export namespace EventProps {
    export type AttendeesModeEnum = 'preset' | 'manual';
    export const AttendeesModeEnum = {
        Preset: 'preset' as AttendeesModeEnum,
        Manual: 'manual' as AttendeesModeEnum
    };
    export type PrivacyEnum = 'public' | 'private' | 'members_only';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        MembersOnly: 'members_only' as PrivacyEnum
    };
}


